module.exports = __webpack_public_path__ + "static/media/logo_1.a0792c6a.svg";